import "mapbox-gl/dist/mapbox-gl.css";
/* eslint import/no-webpack-loader-syntax: off */
import mapboxgl from "!mapbox-gl";
import React, { useState, useRef, useEffect, useContext } from "react";
import SharedDataContext from "../../../_helper/SharedData";
import {
  getCarByCarNumber,
  getCarTrackingByLocation,
  getCarTrackingByServicecity,
  getCarsByCarNumber,
} from "../../../Services/CarTracking.service";
import { showAlert } from "../../../Services/Shared.service";
import {
  Col,
  Form,
  FormGroup,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
} from "reactstrap";
import CustomAutoSuggest from "../../../CommonElements/CustomAutoSuggest";
import { fetchLocation } from "../../../Services/Booking.service";
import { useController, useForm } from "react-hook-form";
import Select from "react-select";
import { Btn } from "../../../AbstractElements";
import OnTripCarIcon from "../../../assets/icons/ontrip-car-icon.svg";
import LoginCarIcon from "../../../assets/icons/login-car-icon.svg";
import LogoutCarIcon from "../../../assets/icons/logout-car-icon.svg";
import OnlineCarIcon from "../../../assets/icons/online-car-icon.svg";
import OfflineCarIcon from "../../../assets/icons/offline-car-icon.svg";
import BlockedCarIcon from "../../../assets/icons/blocked-car-icon.svg";
import AirportZoneCarIcon from "../../../assets/icons/airportzone-car-icon.svg";
import AssignedCarIcon from "../../../assets/icons/assigned-car-icon.svg";
import InactiveCarIcon from "../../../assets/icons/Inactive-car-icon.svg";
import moment from "moment";
import * as turf from "@turf/turf";
import CustomSelect from "../../../CommonElements/CustomSelect";
import { Button, CircularProgress } from "@mui/material";
import { CustomSvgIcon } from "../../../assets/icons/CustomSvgIcon";
import { set } from "lodash";
import SyncIcon from '@mui/icons-material/Sync';
import Tooltip from '@mui/material/Tooltip';

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_ACCESSTOKEN;

const CarTracking = () => {
  const { globalCityField, setShowApiLoader, setPageNumber } =
    useContext(SharedDataContext);
  const mapContainer = useRef(null);
  const map = useRef(null);
  const [lng, setLng] = useState(78.9629);
  const [lat, setLat] = useState(20.5937);
  const [zoom, setZoom] = useState(4);
  const [carData, setCarData] = useState([]);
  const [tab, setTab] = useState("1");
  const [mapMarkers, setMapMarkers] = useState([]);
  const [isSourcePresent, setIsSourcePresent] = useState(false);
  const [isRefresh, setIsRefresh] = useState(false);
  const [mapLoading, setMapLoading] = useState(false);
  const [refreshCabNo,setRefreshCabNo] = useState();
  const[refreshLoad,setRefreshLoad] = useState(false);
  const {
    register,
    handleSubmit,
    control,
    reset,
    resetField,
    getValues,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      locationAddressDropdown: {},
      locationAddress: "",
      cabType: "All",
      radius: "5",
      noOfCabs: "10",
      cabStatus: "All",
      rating: "All",
      carNumber: "",
    },
  });

 

  const cabTypeData = [
    { label: "All", value: "All" },
    { label: "KSTDC", value: "KSTDC" },
    { label: "Megacabs", value: "Megacabs" },
  ];

  const cabStatusData = [
    { label: "All", value: "All" },
    { label: "AirportZone", value: "AirportZone" },
    { label: "Assigned", value: "Assigned" },
    { label: "Blocked", value: "Blocked" },
    // { label: "InActive", value: "InActive" },
    // { label: "LogIn", value: "LogIn" },
    { label: "Logout", value: "Logout" },
    { label: "OffLine", value: "OffLine" },
    { label: "OnLine", value: "OnLine" },
    { label: "OnTrip", value: "OnTrip" },
  ];

  const ratingData = [
    { label: "All", value: "All" },
    { label: ">=3", value: 3 },
    { label: ">=4", value: 4 },
  ];

  const carIcons = {
    OnTrip: OnTripCarIcon,
    LogIn: LoginCarIcon,
    OnLine: OnlineCarIcon,
    Blocked: BlockedCarIcon,
    Logout: LogoutCarIcon,
    AirportZone: AirportZoneCarIcon,
    Assigned: AssignedCarIcon,
    OffLine: OfflineCarIcon,
    InActive: InactiveCarIcon,
  };

  const legendColorsOne = {
    AirportZone: "#FFFF00",
    Assigned: "#8A2BE2",
    Blocked: "#FF0000",
    // InActive: "#C0C0C0",
    // LogIn: "#00FF00",
    Logout: "#808080",
  };

  const legendColorsTwo = {
    OffLine: "#FFC0CB",
    OnLine: "#0000FF",
    OnTrip: "#FFA500",
  };

  const locationAddressField = useController({
    name: "locationAddressDropdown",
    control,
  }).field;

  const handleLocationSelectChange = (data) => {
    locationAddressField.onChange(data.value);
  };

  const carNumberField = useController({
    name: "carNumber",
    control,
  }).field;

  const handleRefreshCarLive = () =>{
    const refreshCabNo = getValues("carNumber")
    if (refreshCabNo) {
        setRefreshLoad(true)
        let obj = {
          carNumber: refreshCabNo,
        };
        getCarByCarNumber(obj)
          .then((result) => {
            setCarData(result.data);
            setRefreshLoad(false)
            if (result.data.length > 0) {
              map.current.setCenter([
                result.data[0]["lng"],
                result.data[0]["lat"],
              ]);
              map.current.setZoom(14);
            }
          })
          .catch((error) => {
            showAlert(
              "error",
              error.response?.data?.message
                ? error.response.data.message
                : "Something went wrong"
            );
          });
    }else{
        showAlert("Select Cab before Referesh")
    }

  }

  const handleCarNumberSelectChange = (data) => {
    setValue("carNumber", data.value?.carNo);

    if (data.value?.carNo) {
      let obj = {
        carNumber: data.value?.carNo,
      };
      getCarByCarNumber(obj)
        .then((result) => {
          setCarData(result.data);
          if (result.data.length > 0) {
            map.current.setCenter([
              result.data[0]["lng"],
              result.data[0]["lat"],
            ]);
            map.current.setZoom(14);
          }
        })
        .catch((error) => {
          showAlert(
            "error",
            error.response?.data?.message
              ? error.response.data.message
              : "Something went wrong"
          );
        });
    } else {
      // fetchCarData()
    }
  };


  const cabTypeField = useController({
    name: "cabType",
    control,
    rules: {},
  }).field;

  const handleCabTypeSelectChange = (data) => {
    cabTypeField.onChange(data.value);
  };

  const cabStatusField = useController({
    name: "cabStatus",
    control,
    rules: {},
  }).field;

  const handleCabStatusSelectChange = (data) => {
    cabStatusField.onChange(data.value);
  };

  const ratingField = useController({
    name: "rating",
    control,
    rules: {},
  }).field;

  const handleRatingSelectChange = (data) => {
    ratingField.onChange(data.value);
  };

  const radiusField = useController({
    name: "radius",
    control,
    rules: {
      required: {
        value: true,
        message: "Radius is required",
      },
    },
  }).field;

  const noOfCabsField = useController({
    name: "noOfCabs",
    control,
    rules: {
      required: {
        value: true,
        message: "Number of Cabs is required",
      },
    },
  }).field;

  // useEffect(() => {
  //     console.log("car number field useeffect", carNumberField.value)
  //     if (carNumberField.value == "" || carNumberField.value == undefined || carNumberField.value == null) {
  //         fetchCarData()
  //     }
  // }, [carNumberField.value])


  useEffect(() => {
    setIsRefresh(false);
    if (locationAddressField.value?.address) {
      setValue("locationAddress", locationAddressField.value?.address);
      setIsRefresh(false);
    } else if (locationAddressField.value) {
      let obj = {
        key: null,
        isAgentApp: true,
        geoApi: true,
        address: locationAddressField.value||null,
        requestSource: "TMS",
      };
      fetchLocation(obj).then((result) => {
        if (result.data.length > 0) {
          locationAddressField.onChange(result.data[0]);
          setIsRefresh(false);
        }
      });
    } else {
      setValue("locationAddress", "");
      setIsRefresh(false);
    }
  }, [locationAddressField.value]);

  // const sampleDatas = [
  //     {
  //         id: 19292,
  //         driverId: 26037,
  //         lat: 13.19957,
  //         lng: 77.7100242,
  //         lastUpdatedOn: "2023-05-12T23:24:14+05:30",
  //         currentCarStatus: "AirportZone",
  //         lastDutyOn: "2023-05-12T14:47:21+05:30",
  //         isAvailableForBid: true,
  //         carNo: "KA-50-A-5980",
  //         todayRevenue: 2968.47,
  //         driverName: "Manharbhai S Vankar",
  //         serviceCityId: 4,
  //         driverMobile: "9429026337",
  //         carModel: "",
  //         carId: 151448,
  //         speedInKmh: "0",
  //         deviceId: "a6eaae40237d47ef",
  //         driverRatingAvg: 5,
  //         carTypeId: 1,
  //         megacabsRating: 0,
  //         aggregatorId: null
  //     },
  //     {
  //         id: 19294,
  //         driverId: 28792,
  //         lat: 13.1993537,
  //         lng: 77.7099031,
  //         lastUpdatedOn: "2023-05-12T23:29:03+05:30",
  //         currentCarStatus: "AirportZone",
  //         lastDutyOn: "2023-05-12T22:38:00+05:30",
  //         isAvailableForBid: true,
  //         carNo: "KA-50-A-5984",
  //         todayRevenue: 2209.19,
  //         driverName: "Prabhakar K",
  //         serviceCityId: 4,
  //         driverMobile: "9964887559",
  //         carModel: "",
  //         carId: 151450,
  //         speedInKmh: "0.33394530415534973",
  //         deviceId: "dc843a5198e8f46e",
  //         driverRatingAvg: 0,
  //         carTypeId: 1,
  //         megacabsRating: 0,
  //         aggregatorId: null
  //     }
  // ]

  // const geojson = {
  //     type: 'FeatureCollection',
  //     features: []
  // };

  useEffect(() => {

  
    // if (map.current) return; // initialize map only once
    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: "mapbox://styles/mapbox/streets-v12",
      center: [lng, lat],
      zoom: zoom,
    });
    // add markers to map
  }, []);

  useEffect(() => {

  
    // if (map.current) return; // initialize map only once
    setIsSourcePresent(false)
    setMapMarkers([])
    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: "mapbox://styles/mapbox/streets-v12",
      center: [lng, lat],
      zoom: zoom,
    });
    // add markers to map
  }, [tab]);


  const fetchCarData = () => {
    setMapLoading(true);
    const serviceCityId = globalCityField.value?.id || 0;
    let obj = {
      serviceCityId: serviceCityId,
      cabType: "All",
    };
      getCarTrackingByServicecity(obj)
        .then((result) => {
          setCarData(result.data);
          map.current.setCenter([lng, lat]);
          map.current.setZoom(zoom);
          setMapLoading(false);
        })
        .catch((error) => {
          showAlert(
            "error",
            error.response?.data?.message
              ? error.response.data.message
              : "Something went wrong"
          );
        });

  };

//   useEffect(() => {
//     // fetchCarData()
//   }, [globalCityField.value]);

useEffect(() => {
  reset({
    locationAddressDropdown: {},
    locationAddress: "",
    cabType: "All",
    radius: "5",
    noOfCabs: "10",
    cabStatus: "All",
    rating: "All",
  });
  
}, [tab]);



  useEffect(() => {
    // if (map.current) {
    //   console.log("useeffect car data", carData);
      mapMarkers.forEach((marker) => marker.remove());
      let newMapMarkers = [];
      for (const data of carData) {
        // create a HTML element for each feature
        const el = document.createElement("div");
        const width = 30;
        const height = 30;
        el.className = "marker";
        el.style.backgroundImage = `url(${carIcons[data.currentCarStatus]})`;
        el.style.width = `${width}px`;
        el.style.height = `${height}px`;
        el.style.backgroundSize = "100%";

        // make a marker for each feature and add it to the map
        const marker = new mapboxgl.Marker(el)
          .setLngLat([data.lng, data.lat])
          .setPopup(
            new mapboxgl.Popup({ offset: 25 }) // add popups
              .setHTML(
                `<div style="margin-top: 10px;">
                                <div style="width: 100%;display: flex;"><p style="margin-bottom: 0px;">${"Vehicle No :"}</p><p style="margin-bottom: 0px;margin-left: 5px;">${
                  data.carNo
                }</p></div>
                                <div style="width: 100%;display: flex;"><p style="margin-bottom: 0px;">${"Driver Name :"}</p><p style="margin-bottom: 0px;margin-left: 5px;">${
                  data.driverName
                }</p></div>
                                <div style="width: 100%;display: flex;"><p style="margin-bottom: 0px;">${"Mobile No :"}</p><p style="margin-bottom: 0px;margin-left: 5px;">${
                  data.driverMobile
                }</p></div>
                                <div style="width: 100%;display: flex;"><p style="margin-bottom: 0px;">${"Rating Avg :"}</p><p style="margin-bottom: 0px;margin-left: 5px;">${
                  data.driverRatingAvg
                }</p></div>
                                <div style="width: 100%;display: flex;"><p style="margin-bottom: 0px;">${"Track Time :"}</p><p style="margin-bottom: 0px;margin-left: 5px;">${moment(
                  data.lastUpdatedOn
                ).format("DD/MM/YYYY hh:mm:ss")}</p></div>
                                <div style="width: 100%;display: flex;"><p style="margin-bottom: 0px;">${"Speed :"}</p><p style="margin-bottom: 0px;margin-left: 5px;">${
                  data.speedInKmh
                } km/h</p></div>
                                <div style="width: 100%;display: flex;"><p style="margin-bottom: 0px;">${"Vehicle Status :"}</p><p style="margin-bottom: 0px;margin-left: 5px;">${
                  data.currentCarStatus
                }</p></div>
                                </div>`
              )
          )
          .addTo(map.current);
        newMapMarkers.push(marker);
      }
      // console.log("newMapMarkers",newMapMarkers)
      setMapMarkers(newMapMarkers);
    // }
  }, [ carData]);



  const getAddressData = async (inputValue) => {
    if (inputValue) {
      let obj = {
        key: inputValue,
        isAgentApp: true,
        geoApi: false,
        address: null,
        requestSource: "TMS",
      };
      return fetchLocation(obj).then((result) => {
        if (result.data.length > 0) {
          let data = result.data.map((element) => {
            return {
              value: element,
              label: element?.address ? element.address : element,
            };
          });
          return data;
        }
        return [];
      });
    }
  };

  const getCarsData = async (inputValue) => {
    if (inputValue) {
      const serviceCityId = globalCityField.value?.id || 0;
      let obj = {
        query: inputValue,
        serviceCityId: serviceCityId,
      };
      return getCarsByCarNumber(obj).then((result) => {
        if (result.data.length > 0) {
          let data = result.data.map((element) => {
            return {
              value: element,
              label: element.carNo,
            };
          });
          return data;
        }
        return [];
      });
    }
  };



  // const metersToPixelsAtMaxZoom = (meters, latitude) =>
  //     meters / 0.075 / Math.cos(latitude * Math.PI / 180)

  const onFormSubmit = (formValues) => {

    let obj = {
      lat: formValues.locationAddressDropdown.lat,
      lng: formValues.locationAddressDropdown.lng,
      carType: formValues.cabType,
      radius: Number(formValues.radius),
      cabCount: Number(formValues.noOfCabs),
      status: formValues.cabStatus,
      rating: formValues.rating,
    };
    getCarTrackingByLocation(obj)
      .then((result) => {
        // map.current.removeSource('source_circle_500');
        setCarData(result.data);
        setIsRefresh(true);
        const ll = new mapboxgl.LngLat(
          formValues.locationAddressDropdown.lng,
          formValues.locationAddressDropdown.lat
        );
        // map.current.setCenter([formValues.locationAddressDropdown.lng, formValues.locationAddressDropdown.lat]);
        const bounds = ll.toBounds(Number(formValues.radius) * 1000).toArray();

        map.current.fitBounds(
          bounds
          // {
          //     padding: { top: 200, bottom: 200, left: 200, right: 200 },
          // }
        );

        let center = [
          formValues.locationAddressDropdown.lng,
          formValues.locationAddressDropdown.lat,
        ];
        let radius = Number(formValues.radius);
        let options = {
          steps: 50,
          units: "kilometers",
          properties: { foo: "bar" },
        };
        let circle = turf.circle(center, radius, options);
        if (isSourcePresent) {
          map.current.getSource("circleData").setData(circle);
        } else {
          map.current.addSource("circleData", {
            type: "geojson",
            data: circle,
          });

          map.current.addLayer({
            id: "circle-fill",
            type: "fill",
            source: "circleData",
            paint: {
              "fill-color": "#39B54A",
              "fill-opacity": 0.5,
            },
          });
          setIsSourcePresent(true);
        }
      })
      .catch((error) => {
        console.log("error", error);
        showAlert(
          "error",
          error.response?.data?.message
            ? error.response.data.message
            : "Something went wrong"
        );
      });
  };

  const cancelBtn = () => {
    reset({
      locationAddressDropdown: {},
      locationAddress: "",
      cabType: "All",
      radius: "5",
      noOfCabs: "10",
      cabStatus: "All",
      rating: "All",
    });
    // fetchCarData()
  };

  return (
    <div className="car-tracking-map">
      <div>
        <div style={{ padding: "20px 0px" }}>
          <Nav
            className="border-tab nav-primary"
            tabs
            style={{ marginBottom: "0px" }}
          >
            <NavItem style={{ cursor: "pointer" }}>
              <NavLink
                className={tab === "1" ? "active" : ""}
                onClick={() => {
                  setTab("1");
                }}
              >
                <i className="fa fa-dot-circle-o"></i>Select by Location
              </NavLink>
            </NavItem>
            <NavItem style={{ cursor: "pointer" }}>
              <NavLink
                className={tab === "2" ? "active" : ""}
                onClick={() => setTab("2")}
              >
                <i className="fa fa-automobile"></i>Select by Car
              </NavLink>
            </NavItem>
          </Nav>
        </div>
        <div>
          {tab == "1" ? (
            <Form
              onSubmit={handleSubmit(onFormSubmit)}
              style={{
                display: tab == "1" ? "block" : "none",
                marginBottom: "15px",
              }}
            >
              <Row>
                <FormGroup className="col-lg-7">
                  <Label className="col-lg-12 col-form-label">Location</Label>
                  <Col lg="12">
                    <CustomAutoSuggest
                      id={"Location"}
                      handleSelectChange={handleLocationSelectChange}
                      options={getAddressData}
                      placeholder="Enter location"
                      registerName={"locationAddress"}
                      register={register}
                      isClearable={true}
                      setValue={setValue}
                      watch={watch}
                      inputProps={{
                        required: {
                          value: true,
                          message: "Location is required",
                        },
                      }}
                      dependentRegisterName={"locationAddressDropdown"}
                      
                    />
                    <span style={{ color: "red" }}>
                      {errors?.locationAddress?.message}
                    </span>
                  </Col>
                </FormGroup>
                <FormGroup className="col-lg-5">
                  <Label className="col-lg-12 col-form-label">Cab Type</Label>
                  <Col lg="12">
                    <div className="city-select">
                      <CustomSelect
                        className="service-select"
                        classNamePrefix="select"
                        isClearable={false}
                        isSearchable={false}
                        value={
                          cabTypeField?.value
                            ? cabTypeData.find((element) => {
                                return element?.value === cabTypeField?.value;
                              })
                            : ""
                        }
                        // defaultValue={cityData.find((element) => {
                        //   console.log(cityField?.value?.id,element?.value?.id,'element?.value?.idelement?.value?.id');
                        //   return element?.value?.id === cityField?.value?.id;
                        // })}
                        onChange={handleCabTypeSelectChange}
                        placeholder="Select Cab Type"
                        options={cabTypeData}
                      />
                    </div>
                    <span style={{ color: "red" }}>
                      {errors?.cabType?.message}
                    </span>
                  </Col>
                </FormGroup>
              </Row>
              <Row>
                <FormGroup className="col-lg-3">
                  <Label className="col-lg-12 col-form-label">Radius</Label>
                  <Col lg="12">
                    <input
                      className="form-control"
                      type="text"
                      onChange={(e) => {
                        let value = e.target.value.replace(/[^0-9]/g, "");
                        if (value === "0") {
                          radiusField.onChange("");
                        } else {
                          radiusField.onChange(value);
                        }
                      }}
                      value={radiusField.value}
                      maxLength={2}
                    />
                    <span style={{ color: "red" }}>
                      {errors?.radius?.message}
                    </span>
                  </Col>
                </FormGroup>
                <FormGroup className="col-lg-3">
                  <Label className="col-lg-12 col-form-label">
                    Number of Cabs
                  </Label>
                  <Col lg="12">
                    <input
                      className="form-control"
                      type="text"
                      onChange={(e) => {
                        let value = e.target.value.replace(/[^0-9]/g, "");
                        if (value === "0") {
                          noOfCabsField.onChange("");
                        } else {
                          noOfCabsField.onChange(value);
                        }
                      }}
                      value={noOfCabsField.value}
                      maxLength={4}
                    />
                    <span style={{ color: "red" }}>
                      {errors?.noOfCabs?.message}
                    </span>
                  </Col>
                </FormGroup>
                <FormGroup className="col-lg-3">
                  <Label className="col-lg-12 col-form-label">Cab Status</Label>
                  <Col lg="12">
                    <div className="city-select">
                      <CustomSelect
                        className="service-select"
                        classNamePrefix="select"
                        isClearable={false}
                        isSearchable={false}
                        value={
                          cabStatusField?.value
                            ? cabStatusData.find((element) => {
                                return element?.value === cabStatusField?.value;
                              })
                            : ""
                        }
                        // defaultValue={cityData.find((element) => {
                        //   console.log(cityField?.value?.id,element?.value?.id,'element?.value?.idelement?.value?.id');
                        //   return element?.value?.id === cityField?.value?.id;
                        // })}
                        onChange={handleCabStatusSelectChange}
                        placeholder="Select Cab Status"
                        options={cabStatusData}
                      />
                    </div>
                    <span style={{ color: "red" }}>
                      {errors?.cabStatus?.message}
                    </span>
                  </Col>
                </FormGroup>
                <FormGroup className="col-lg-3">
                  <Label className="col-lg-12 col-form-label">
                    Megacabs Rating
                  </Label>
                  <Col lg="12">
                    <div className="city-select">
                      <CustomSelect
                        className="service-select"
                        classNamePrefix="select"
                        isClearable={false}
                        isSearchable={false}
                        value={
                          ratingField?.value
                            ? ratingData.find((element) => {
                                return element?.value === ratingField?.value;
                              })
                            : ""
                        }
                        // defaultValue={cityData.find((element) => {
                        //   console.log(cityField?.value?.id,element?.value?.id,'element?.value?.idelement?.value?.id');
                        //   return element?.value?.id === cityField?.value?.id;
                        // })}
                        onChange={handleRatingSelectChange}
                        placeholder="Select Megacabs Rating"
                        options={ratingData}
                      />
                    </div>
                    <span style={{ color: "red" }}>
                      {errors?.rating?.message}
                    </span>
                  </Col>
                </FormGroup>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-primary cancel-button"
                    onClick={cancelBtn}
                  >
                    {"Cancel"}
                  </button>
                  <button type="submit" className="btn btn-primary">
                    {isRefresh ? "Refresh" : "Get"}
                  </button>
                </div>
              </Row>
            </Form>
          ) : (
            <Row>
              <FormGroup  className="d-flex  gap-4">
                <Col lg="8">

                  <CustomAutoSuggest
                    id={"carNumber"}
                    handleSelectChange={handleCarNumberSelectChange}
                    options={getCarsData}
                    placeholder="Enter Car Number"
                    registerName={"carNumber"}
                    register={register}
                    isClearable={true}
                    setValue={setValue}
                    watch={watch}
                  />
                  <span style={{ color: "red" }}>
                    {errors?.carNumber?.message}
                  </span>
                </Col>
                <Col>
                <Tooltip title="Click to retrieve the cab's current latitude and longitude. Refreshes every 30 seconds.">
                <Button variant="contained" color="success" startIcon={refreshLoad ? <CircularProgress  color="primary"
                style={{ color: "#fff", width: "1.5rem", height: "1.5rem" }} /> :<SyncIcon/>} onClick={()=>{handleRefreshCarLive()}}>Refresh</Button>
                </Tooltip>
                </Col>
            
              </FormGroup>
            </Row>
          )}
        </div>
      </div>
      <div className="legend">
        {Object.keys(legendColorsOne).map((key) => {
          return (
            <div className="individual">
              <span style={{ background: legendColorsOne[key] }}></span>
              <span>{key}</span>
            </div>
          );
        })}
      </div>
      <div className="legend">
        {Object.keys(legendColorsTwo).map((key) => {
          return (
            <div className="individual">
              <span style={{ background: legendColorsTwo[key] }}></span>
              <span>{key}</span>
            </div>
          );
        })}
      </div>
      {/* <button type="button" className="btn btn-primary cancel-button" onClick={fetchCarData}>
                                          {mapLoading?"Loading...":"Go Live"}
            </button> */}
      <div
        style={{ display: "flex", justifyContent: "right", marginBottom: "1%" }}
      >
        <Tooltip title="Click to display the locations of all cabs around India on the map">
        <Button
          onClick={() => {
            fetchCarData()
          }}
          variant="contained"
          type="button"
          color="success"
          startIcon={
            mapLoading ? (
              <CircularProgress
                color="primary"
                style={{ color: "#fff", width: "1.5rem", height: "1.5rem" }}
              />
            ) : (
              <CustomSvgIcon />
            )
          }
        >
          All Cabs
        </Button>
        </Tooltip>
      </div>
      <div ref={mapContainer} className="map-container" />
    </div>
  );
};

export default CarTracking;
